import { Advisory } from '../model/advisory';
import { Undefinedable } from 'gocclr-shared-ui/dist/helpers';
import { createGlobalState } from 'react-hooks-global-state';

export interface AppState {
    rawHeader: Undefinedable<string>;
    rawAlerts: Undefinedable<string>;
    rawFooter: Undefinedable<string>;
    advisories: Advisory[];
}

const initialState: AppState = {
    rawAlerts: undefined,
    rawFooter: undefined,
    rawHeader: undefined,
    advisories: []
};

const { useGlobalState, getGlobalState, setGlobalState } = createGlobalState(initialState);
export const useAppState = useGlobalState;
export const getAppState = getGlobalState;
export const setAppState = setGlobalState;

